import GroupManagement from "../js/components/groupManagement/GroupManagement.react";
export default GroupManagement;
